import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import ObservationCard from './ObservationCard'
import { Card, CardContent } from '@mui/material'
import { CardTitle } from '../../../components/card/NewCard'
import { maxBy, orderBy } from 'lodash'
import { shallowEqual, useSelector } from 'react-redux'

const LastObservationsPanel = ({ readMode = true }) => {
    const {
        hydrometryObservations,
    } = useSelector(store => ({
        hydrometryObservations: store.HydrometryReducer.hydrometryObservations,
    }), shallowEqual)

    const lastObservation = maxBy(hydrometryObservations, observation => observation?.observationDate || 0)
    const observationLast = useMemo(() => {
        return lastObservation ? orderBy(hydrometryObservations, ['observationDate', 'updateDate'], ['desc', 'desc'])
            .filter(observation => observation.observationDate == lastObservation.observationDate) : []
    }, [hydrometryObservations, lastObservation])

    return !!observationLast.length && (
        <Card sx={{ marginTop: '10px' }}>
            <CardTitle title={i18n.lastObservations} />
            <CardContent>
                {observationLast.map(observation => (
                    <ObservationCard observation={observation} readMode={readMode} />
                ))}
            </CardContent>
        </Card>
    )
}

LastObservationsPanel.propTypes = {
    hydroId: PropTypes.number.isRequired,
    readMode: PropTypes.bool,
}

export default LastObservationsPanel